import { Admin, State } from '../../types'

export const getAdmin = (state: State, id: string): Admin => {
  return state.AdminById[id]
}
